import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const plug: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.719-8.469q.28.299.281.719a.98.98 0 0 1-.281.703l-3.14 3.125L11.75-2.75 10.5-1.5A4.92 4.92 0 0 1 7.453-.047Q5.684.143 4.25-.828L1.422 2H0V.594L2.828-2.25q-.97-1.434-.781-3.203A4.92 4.92 0 0 1 3.5-8.5l1.25-1.25 1.172 1.172 3.125-3.14A.98.98 0 0 1 9.75-12c.281 0 .516.102.703.297a.94.94 0 0 1 .297.703.98.98 0 0 1-.281.703L7.344-7.172l1.828 1.828 3.125-3.125A.98.98 0 0 1 13-8.75q.421 0 .719.281m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "14",
    width: "14",
  }
};
